export default Object.freeze({
  List: 'list',
  Gantt: 'gantt',
  Calendar: 'calendar',
  TaskList: 'task-list',
  TaskBoard: 'task-board',
  CardsList: 'cards-list',
  MapList: 'map-list',
});
